<template>
  <div
    v-if="isVisible"
    ref="modal"
    role="dialog"
    aria-modal="true"
    tabindex="-1"
    class="ra-user-redirect-modal"
    :data-refapp-tagging-id="taggingId"
    data-refapp-tagging-target="ra-user-redirect-modal"
    @keydown.esc="handleClose"
  >
    <refapp-redirect-options
      :image="image"
      :title="title"
      :description="description"
      :countries="countries"
      :cookie-expiration="cookieExpiration"
      :redirect-label="redirectLabel"
      :continue-label="continueLabel"
      :default-country-code="defaultCountryCode"
      :btn-bg-color="btnBgColor"
      :btn-text-color="btnTextColor"
      :close-btn-aria-label="closeBtnAriaLabel"
      @close-button-handler="handleClose"
      @continue-button-handler="handleContinue"
      @set-cookie="setCookie"
    />
  </div>
</template>

<script>
import RefappRedirectOptions from './base/refapp-redirect-options.vue';
import tagging from '../lib/tagging/mixin';
import { redirectOptionsProps } from './base/props-definitions';
import { trapFocus } from '../../../shared/utils/dom/focus';

export default {
  name: 'refapp-user-redirect',
  components: {
    RefappRedirectOptions,
  },
  mixins: [tagging],
  props: {
    taggingId: {
      type: String,
      required: true,
    },
    ...redirectOptionsProps,
  },
  data() {
    return {
      isVisible: this.$cookies.get('geoip-redirect') === null,
      deactivateFocusTrap: null,
    };
  },
  watch: {
    isVisible: {
      async handler(newVal) {
        await this.$nextTick();

        if (newVal) {
          this.deactivateFocusTrap = trapFocus(this.$refs.modal);
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleClose() {
      this.performCloseModalActions();
      this.dispatchCloseModalTaggingEvent();
    },
    handleContinue() {
      this.performCloseModalActions();
    },
    setCookie() {
      this.$cookies.set('geoip-redirect', true, this.cookieExpiration);
    },
    performCloseModalActions() {
      this.setCookie();
      this.isVisible = false;
      this.deactivateFocusTrap();
      this.deactivateFocusTrap = null;
    },
    dispatchCloseModalTaggingEvent() {
      const htmlEvent = new Event('close-redirect-popup');
      this.$el.dispatchEvent(htmlEvent);
    },
  },
};
</script>

<style lang="scss" src="../styles/entry.scss"></style>
